import { RolesOrderBy, RolesService } from "../client"

/* Interfaces */
export interface AddRoleProps {
  onClose: () => void
  isOpen: boolean
}

export interface RoleProps {
  onClose: () => void
  isOpen: boolean
  roleId: string
}


/* Endpoints */
export const readRoles = ({
  order_by,
  descending,
  query,
}: {
  order_by?: RolesOrderBy
  descending?: boolean
  query?: string
}) => {
    return {
        queryFn: async () => {
        const data = await RolesService.readRoles({
            orderBy: order_by,
            descending: descending,
            query: query,
        })

        return data ?? { data: null, count: 0 }
        },
        queryKey: ["roles", { order_by, descending, query }],
    }
}

export const readRolesList = () => {
  return {
    queryFn: async () => {
      const data = RolesService.readRoles()

      return data ?? { data: null, count: 0 }
    },
    queryKey: ["roles"],
  }
}

export const readRoleById = (roleId: string) => {
  return {
    queryFn: async () => {
      const data =  RolesService.readRoleById({roleId: roleId,})

      return data ?? { data: null, count: 0 }
    },
    queryKey: ["role", { roleId }],
  }
}